module.exports = __webpack_public_path__ + "img/3Bar Biologics Inc..1c7274ed.png";